// extracted by mini-css-extract-plugin
export default {"genre1":"BadgeStyle_genre1__yKprc"};